<template>
    <div class="mt-5 mb-5">
        <div class="row">
            <div class="row">
                <div class="col ml-3">
                    <strong>Keywords</strong>
                </div>
            <!-- <div class="col text-right mb-2">
                <button class="btn btn-primary" data-toggle="modal" data-target="#addKeywords">Add Keywords</button>
            </div> -->
            </div>
            <div class="col text-right mb-2">
                <button class="btn btn-primary" data-toggle="modal" data-target="#addKeywords" @click="addNewKeyword">Add Keywords</button>
            </div>
        </div>
        <div class="table-responsive" v-if="keywordList.length > 0">
            <table class="table">
                <thead>
                    <tr>
                        <th style="width:50%">Keywords</th>
                        <th style="width:40%">Type</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, k) in keywordList" :key="k">
                        <td><ProductListChipView :productList="keywordList[k].keyword"></ProductListChipView></td>
                        <!-- {{ item.keyword }} -->
                        <td>{{ item.type }}</td>
                        <td>
                            <a href="javascript:void(0)" class="mr-2" data-toggle="modal" data-target="#addKeywords" @click="editSelectedKeyword(item, k)">Edit </a>
                            <a href="javascript:void(0)" @click="openRemoveKeywordModal(item, k)"> Remove</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <hr />
        <div>
            <button class="btn btn-secondary" @click="navigateToProductList">Cancel</button>
            <button class="btn btn-primary" @click="saveNewProduct">Save</button>
        </div>
        <RemoveKeywordConfirmModal @removeKeyword="deleteSelectedKeyword"></RemoveKeywordConfirmModal>
    </div>
</template>

<script>
import ProductListChipView from '@/components/product/ProductListChipView'
import RemoveKeywordConfirmModal from '@/components/add-product/RemoveKeywordConfirmModal'

export default {
    name: 'AddProductKeywordGrid',
    props: {
        keywordList: {
            type: Array,
            default: []
        }
    },
    components: {
        ProductListChipView,
        RemoveKeywordConfirmModal,
    },
	mounted(){
		console.log(this.keywordList);
	},
    methods: {
        navigateToProductList() {
            this.$router.push({path:'/productList'})
            this.$store.state.calledFromCancel = true;
        },
        saveNewProduct() {
            this.$emit('saveNewProduct')
        },
        editSelectedKeyword(item, keywordIndex) {
			//
            item['keywordIndex'] = keywordIndex
            this.$emit('editSelectedKeyword', item)
        },
        openRemoveKeywordModal(item, keywordIndex) {
            this.selectedKeywordIndex = keywordIndex
            $('#confirmRemoveKeywordP').modal('show')
        },
        deleteSelectedKeyword() {
            this.$emit('deleteSelectedKeyword', this.selectedKeywordIndex)
            $('#confirmRemoveKeywordP').modal('hide')
        },
        resetSelectedProduct() {
            this.$emit('resetSelectedProduct');
        },
        addNewKeyword() {
            // this.resetSelectedProduct();
        }
    }
}
</script>

<style lang="scss">

</style>
